angular.module("app").controller("colorUnicornController", [
  "$scope",
  function (
    scope
  ) {

  },
]);
